import { startOperation } from '@mint-lib/datadog';
import { useTranslation } from '@mint-lib/i18n';
import {
  Copy,
  Delete,
  OverflowMenuVertical,
  Package,
  User,
} from '@mint-lib/icons';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@mint-lib/tw-components';
import { Link as RouterLink } from '@mint/routing';

import { useImportHubPaths } from '../../hooks/useImportHubRouteApi.js';

interface TemplateMoreActionsProps {
  templateId: string;
  onCollaboratorsClick: () => void;
  onDuplicateClick: () => void;
  onDeleteClick: () => void;
}

export const GridTemplateMoreActions = ({
  templateId,
  onCollaboratorsClick,
  onDuplicateClick,
  onDeleteClick,
}: TemplateMoreActionsProps) => {
  const { t } = useTranslation('@myn/import-hub');
  const paths = useImportHubPaths();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="plain"
          size="small"
          className="data-[state=open]:outline-[2px]"
          aria-label={t('More actions')}
          data-dd-action-name="More actions"
        >
          <OverflowMenuVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px]">
        <DropdownMenuItem
          className="gap-2"
          data-dd-action-name="Import data using template"
        >
          <Package />
          <RouterLink
            className="whitespace-nowrap"
            to={paths.importsNew}
            search={{ template: templateId }}
            onClick={() => {
              // Ended by useImportOperation in the data file wizard.
              startOperation('import-hub.import');
            }}
          >
            {t('Import with this template')}
          </RouterLink>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="gap-2"
          data-dd-action-name="Add template collaborators"
          onClick={() => {
            onCollaboratorsClick();
          }}
        >
          <User />
          {t('Add collaborators')}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="gap-2"
          data-dd-action-name="Duplicate template"
          onClick={() => {
            onDuplicateClick();
          }}
        >
          <Copy />
          {t('Duplicate')}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="gap-2 fill-text-error text-text-error"
          data-dd-action-name="Delete template"
          onClick={() => {
            onDeleteClick();
          }}
        >
          <Delete />
          {t('Delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
